module.exports = __webpack_public_path__ + "static/img/z10.8e8b18f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/z10.png
// module id = AFzI
// module chunks = 0